/**
 * Returns the given hex color with an applied alpha component, in `rgba()`
 * form. Supports `#RGB`, `#RGBA`, `#RRGGBB`, and `#RRGGBBAA`. Non-hex inputs
 * (already `rgba(...)`, named colors) are returned unchanged.
 *
 * Used for per-tag accent tints (tag.color → background at 13% opacity etc.)
 * where Tailwind can't help because the color is dynamic.
 *
 * Ported from mobile-app/src/utils/withAlpha.ts.
 */
export function withAlpha(color: string, alpha: number): string {
  if (!color || !color.startsWith('#')) return color;
  const hex = color.slice(1);
  let r = 0;
  let g = 0;
  let b = 0;

  if (hex.length === 3 || hex.length === 4) {
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  } else if (hex.length === 6 || hex.length === 8) {
    r = parseInt(hex.slice(0, 2), 16);
    g = parseInt(hex.slice(2, 4), 16);
    b = parseInt(hex.slice(4, 6), 16);
  } else {
    return color;
  }

  const clamped = Math.max(0, Math.min(1, alpha));
  return `rgba(${r}, ${g}, ${b}, ${clamped})`;
}
